import React from "react";

export function WB_MediaImage({}) {
    return <div className="w-full rounded-lg bg-gray-200" style={{paddingBottom:'60%'}}>

    </div>
}